import * as React from 'react';
import styles from './details-expander.scss';
import { Triangle } from 'ui';

export interface DetailsExpanderProps {
  id?: string;
  className?: string;
  expandAll?: boolean;
  children?: React.ReactNode;
}

export const DetailsExpander: React.FC<DetailsExpanderProps> = ({id, className, children, expandAll}) => {
  return (
    <div className={`${styles.detailsExpander} details-expander`}>
      {!expandAll && <Triangle/>}
      <div id={id} className={`${!expandAll ? styles.collapseContainer : ''} ${className} collapse show container dialog-expander`}>
        <div className={`${styles.expander} ${expandAll ? styles.noShadow : ''}`}>
          {children}
        </div>
      </div>
    </div>
  );
};
